import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./Table.module.scss";

const Table = forwardRef(({ highlightRows, className, component: Component, ...rest }, ref) => {
  return (
    <Component
      ref={ref}
      className={cn(styles.container, { [styles.highlightRows]: highlightRows }, className)}
      {...rest}
    />
  );
});

Table.displayName = "Table";

Table.defaultProps = {
  className: undefined,
  highlightRows: false,
  component: "table"
};

Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,
  /**
   * Make rows highlighted.
   */
  highlightRows: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType
};

export default Table;
